import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import delve from 'dlv';

// import { storage } from '../../../config';
import { fetchDemographics } from '../../../store/actions';
import { ESRI_RADII_DEFAULTS, ESRI_YEAR_DEFAULTS } from '../../../constants';
import ConditionalWrapper from '../../ConditionalWrapper/ConditionalWrapper';

import { PopulationDemographics } from './PopulationDemographics';
import { HouseholdsDemographics } from './HouseholdsDemographics';

export class PropertyDetailDemographicsComponent extends Component {
  constructor(props) {
    super(props);

    this.state = {
      longitude: null,
      latitude: null,
    };
    this.radii = this.setEsriRadii(this.props.viewer.esriRadii);
    this.requestDemographics = this.requestDemographics.bind(this);

    this.hasMinutes = delve(this.props.viewer, 'componentDisplayOrder.demographicsMinutes');

    if (this.hasMinutes) {
      this.minutes = {
        minuteOne: this.props.viewer.componentDisplayOrder.demographicsMinutes.minuteOne,
        minuteTwo: this.props.viewer.componentDisplayOrder.demographicsMinutes.minuteTwo,
        minuteThree: this.props.viewer.componentDisplayOrder.demographicsMinutes.minuteThree,
      };
    }
  }

  componentWillMount() {
    const { property = {} } = this.props;
    const coordinates = delve(property, 'basicInfo.location.geoLocation.coordinates', []);
    const [longitude, latitude] = coordinates;

    if (longitude && latitude) {
      this.requestDemographics(longitude, latitude);
    }
  }

  componentWillReceiveProps(nextProps) {
    const { property = {} } = nextProps;
    const coordinates = delve(property, 'basicInfo.location.geoLocation.coordinates', []);
    const [longitude, latitude] = coordinates;
    const { longitude: lng, latitude: lat } = this.state;

    if (longitude && latitude && (longitude !== lng || latitude !== lat)) {
      this.requestDemographics(longitude, latitude);
    }
  }

  setEsriRadii(radii) {
    if (radii) {
      const radiiCopy = radii;
      if (!radii.radiusOne) {
        radiiCopy.radiusOne = ESRI_RADII_DEFAULTS.radiusOne;
      }
      if (!radii.radiusTwo) {
        radiiCopy.radiusTwo = ESRI_RADII_DEFAULTS.radiusTwo;
      }
      if (!radii.radiusThree) {
        radiiCopy.radiusThree = ESRI_RADII_DEFAULTS.radiusThree;
      }
      return radiiCopy;
    }
    return ESRI_RADII_DEFAULTS;
  }

  requestDemographics(longitude, latitude) {
    this.setState(prevState => ({
      ...prevState,
      longitude,
      latitude,
    }), () => {
      const { getDemographics, type } = this.props;
      const { longitude: lng, latitude: lat } = this.state;
      const coordinates = [lng, lat];
      if (this.hasMinutes) {
        getDemographics(coordinates, this.minutes, type, true);
      } else {
        getDemographics(coordinates, this.radii, type);
      }
    });
  }

  render() {
    const { property = {} } = this.props;
    const population = delve(property, 'demographics.population');
    const households = delve(property, 'demographics.households');
    let overviewSectionsToShow;
    if (this.props.type === 'buildings') {
      overviewSectionsToShow = this.props.viewer.buildingSettings.overviewSectionsToShow;
    } else {
      overviewSectionsToShow = this.props.viewer.siteSettings.overviewSectionsToShow;
    }

    if (!population || !households) {
      return (
        // <div>
        //   <img
        //     alt="loading gif"
        //     src={`${storage.distPath}/loading.gif`}
        //   />
        // </div>
        <div>
          {/* <p>Empty Div</p> */}
        </div>
      );
    }

    return (
      <div>
        <ConditionalWrapper condition={!overviewSectionsToShow || overviewSectionsToShow.includes('Population')}>
          <PopulationDemographics
            population={population}
            radii={this.radii}
            viewer={this.props.viewer}
          />
        </ConditionalWrapper>
        <ConditionalWrapper condition={!overviewSectionsToShow || overviewSectionsToShow.includes('Households')}>
          <HouseholdsDemographics
            households={households}
            radii={this.radii}
            viewer={this.props.viewer}
          />
        </ConditionalWrapper>
        <div className="data-credit">
          Demographics Source: ESRI<sup>&reg;</sup>, { ESRI_YEAR_DEFAULTS.currentYear }
        </div>
      </div>
    );
  }
}

// ToDo: Create a building proptype and import
PropertyDetailDemographicsComponent.propTypes = {
  getDemographics: PropTypes.func.isRequired,
  property: PropTypes.object.isRequired,
  type: PropTypes.string.isRequired,
  viewer: PropTypes.object.isRequired,
};

export function mapDispatchToProps(dispatch) {
  return {
    getDemographics(coordinates, radii, type, minutesFlag) {
      dispatch(fetchDemographics(coordinates, radii, type, minutesFlag));
    },
  };
}

export default connect(null, mapDispatchToProps)(PropertyDetailDemographicsComponent);



// WEBPACK FOOTER //
// ./src/components/PropertyDetail/PropertyDetailDemographics/PropertyDetailDemographics.js